import { makeStyles } from '@material-ui/core';
import { FunctionComponent } from 'react';
import { ChipField, ListProps, ReferenceArrayField, SingleFieldList } from 'react-admin';
import AppEditButton from '../../../Components/ui/button/AppEditButton';
import AppDatagrid from '../../../Components/ui/datagrid/AppDatagrid';
import AppList from '../../../Components/ui/detail/AppList';
import AppTextField from '../../../Components/ui/field/AppTextField';
import AppTitle from '../../../Components/ui/layout/AppTitle';

const useStyles = makeStyles(
  (theme) => ({
    title: {
      minWidth: theme.spacing(50),
    },
    slug: {
      minWidth: theme.spacing(60),
    },
    lastCol: {
      width: '100%',
    },
  }),
  { name: 'PageList' },
);

const IS_IVG = process.env.REACT_APP_IS_IVG === 'true';

const PageList: FunctionComponent<ListProps> = (props) => {
  const classes = useStyles();

  return (
    <AppList {...props} title={<AppTitle title="Pagine" />}>
      <AppDatagrid resource="pages" rowClick="show">
        <AppTextField source="header" label="Titolo" headerClassName={classes.title} />
        <AppTextField source="slug" label="Slug" headerClassName={classes.slug} />
        {!IS_IVG && (
          <ReferenceArrayField
            reference="properties"
            source="propertyIds"
            label="Siti"
            headerClassName={classes.lastCol}
          >
            <SingleFieldList>
              <ChipField source="name" style={{ marginBottom: '15px' }} />
            </SingleFieldList>
          </ReferenceArrayField>
        )}
        <AppEditButton />
      </AppDatagrid>
    </AppList>
  );
};

export default PageList;
